
import  React from "react"
import { useEffect, useState } from "react"
import styles from "./style.module.scss"
import { BsCalendarEvent, BsClockHistory } from "react-icons/bs"


const CountDown = ({ targetDate, color = "#feac24" }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    expired: false,
  })

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date()
      const distance = new Date(targetDate).getTime() - now.getTime()

      if (distance < 0) {
        clearInterval(timer)
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          expired: true,
        })
        return
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24))
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((distance % (1000 * 60)) / 1000)

      setTimeLeft({ days, hours, minutes, seconds, expired: false })
    }, 1000)

    return () => clearInterval(timer)
  }, [targetDate])

  if (timeLeft.expired) {
    return (
      <div className={styles.countDown} style={{ "--countdown-color": color } }>
        <div className={styles.expiredContainer}>
          <BsCalendarEvent className={styles.expiredIcon} />
          <span className={styles.expiredText}>Finalizado</span>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.countDown} style={{ "--countdown-color": color } }>
      <div className={styles.timeContainer}>
        <div className={styles.timeUnit}>
          <div className={styles.timeValue}>{timeLeft.days.toString().padStart(2, "0")}</div>
          <div className={styles.timeLabel}>d</div>
        </div>

        <div className={styles.timeSeparator}>:</div>

        <div className={styles.timeUnit}>
          <div className={styles.timeValue}>{timeLeft.hours.toString().padStart(2, "0")}</div>
          <div className={styles.timeLabel}>h</div>
        </div>

        <div className={styles.timeSeparator}>:</div>

        <div className={styles.timeUnit}>
          <div className={styles.timeValue}>{timeLeft.minutes.toString().padStart(2, "0")}</div>
          <div className={styles.timeLabel}>m</div>
        </div>

        <div className={styles.timeSeparator}>:</div>

        <div className={styles.timeUnit}>
          <div className={styles.timeValue}>{timeLeft.seconds.toString().padStart(2, "0")}</div>
          <div className={styles.timeLabel}>s</div>
        </div>
      </div>

      {timeLeft.days === 0 && timeLeft.hours < 6 && (
        <div className={styles.urgentBadge}>
          <BsClockHistory />
          <span>Últimas horas!</span>
        </div>
      )}
    </div>
  )
}

export default CountDown
